import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ResetPasswordLink.css'; // Your custom styling file
import Util from './ait/Util.js';
import Swal from 'sweetalert2';
import { useParams } from "react-router-dom";


const ResetPasswordLink = ({isLoggedIn, onLogout }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();

  const handlePasswordChange = (e) => setPassword(e.target.value);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  const handleLoginClick = async (e) => 
  {
    e.preventDefault();
    console.log("ready for lunch");
    if(isLoggedIn==true)
    {
        console.log("Help");
        await onLogout();
    }
    navigate ('./login');
    
  }

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    let ut = Util.getInstance();
        
    let rt=ut.isStrongPassword(password);
    if(!rt)
    {
      let msg = 'password is not strong enough. Ensure length is atleast 8 characters, atleast 1 lowercase, at least 1 uppercase, at least 1 digit and at least 1 special character';
      setError(msg);
      setLoading(false);
      return;
    }


    const command = Util.serverName + "/api/checkReset"; // Base API endpoint

      // Make the API call using POST method with a JSON body
    try
    {    
      const response = await fetch(command, {
          method: 'POST', // Use POST method
          headers: { 'Content-Type': 'application/json' }, // Specify JSON format
          body: JSON.stringify({link:token, password:password }), // JSON payload
        })
      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        setError(data.message);
        setLoading(false);
        return;
  
      }

      if (!data.status) {
        setError(data.message);
        setLoading(false);
        return;
      }       

      Swal.fire({
        title: 'Info',
        text: "Password Changed Successfully, Please go to login",
        icon: 'info',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,    
      });        

      setSuccess("Password Changed Successfully. Please go to login")

    }
    catch(error)
    {
        setError(error.message);
        setLoading(false);
        return;
    }
    finally {
        setLoading(false);
    }
  };

  let refMsg = "Login Here"
  if(isLoggedIn == true)
  {
    refMsg = "Logout Here"
  } 
  
  return (
    <div className="reset-password-container">
      <div className="reset-password-content">
        <h2 className="reset-password-title">Reset Your Password</h2>
        <p className="reset-password-message">
          Please enter your new password below. It must be at least 8 characters long.
        </p>
        
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}

        <form onSubmit={handleResetPassword}>
          <div className="password-input-container">
            <input
              type={isPasswordVisible ? 'text' : 'password'}
              value={password}
              onChange={handlePasswordChange}
              placeholder="New Password"
              className="password-input"
            />
            <span
              className="password-toggle-icon"
              onClick={togglePasswordVisibility}
            >
              {isPasswordVisible ? '👁️' : '🙈' }
            </span>
          </div>

          <button type="submit" className="reset-button" disabled={loading}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>        
            <p className="login-redirect-message">
                Remembered your password?
                <a href="/login" onClick={handleLoginClick}>{refMsg}</a>                 
            </p>
      </div>
    </div>
  );
};

export default ResetPasswordLink;
